module.exports = __webpack_public_path__ + "img/halo.fa9b92e.jpg";